import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditTeamForm } from '../-components/TeamForm';

export const Route = createFileRoute('/_authenticated/teams/iceHockeyTeams/$id')({
    context: ({ params }) => ({
        teamQuery: client.liveticker.teams.get.queryOptions(
            { params: { id: Number(params.id) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.teamQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: () => <EditTeamForm sportType="iceHockey" />,
});
